import { PERMISSIONS } from "@/utils/constants";
import authMiddleware from "@/router/middlewares/authMiddleware";
import permissionMiddleware from "@/router/middlewares/permissionMiddleware";

export default [
  {
    path: "/omtk-orders",
    name: "omtk-orders",
    component: () => import("../pages/admin/omtk/order"),
  },
  {
    path: "/omtk-contracts",
    name: "omtk-contracts",
    props: true,
    component: () => import("../pages/admin/omtk/contract.vue"),
  },
  {
    path: "/omtk-lots",
    name: "omtk-lots",
    props: true,
    component: () => import("../pages/admin/omtk/lot.vue"),
    meta: {
      middleware: [authMiddleware, permissionMiddleware(PERMISSIONS.OMTK)],
    },
  },
  {
    path: "/omtk-placement",
    name: "omtk-placement",
    props: true,
    component: () => import("../pages/admin/omtk/placement.vue"),
    meta: {
      middleware: [authMiddleware, permissionMiddleware(PERMISSIONS.OMTK)],
    },
  },
  {
    path: "/product-delivery",
    name: "omtk-productDelivery",
    props: true,
    component: () => import("../pages/admin/omtk/delivery.vue"),
    meta: {
      middleware: [authMiddleware, permissionMiddleware(PERMISSIONS.OMTK)],
    },
  },
  {
    path: "/unreceived-products",
    name: "omtk-unreceivedProducts",
    props: true,
    component: () => import("../pages/admin/omtk/unreceived-products.vue"),
    meta: {
      middleware: [authMiddleware, permissionMiddleware(PERMISSIONS.OMTK)],
    },
  },
  {
    path: "/inventarization",
    name: "omtk-inventarization",
    props: true,
    component: () => import("../pages/admin/omtk/inventarization.vue"),
    meta: {
      middleware: [authMiddleware, permissionMiddleware(PERMISSIONS.INVENTORY)],
    },
  },
  {
    path: "/inventarization/:id",
    name: "omtk-inventarization-item",
    props: true,
    component: () => import("../pages/admin/omtk/inventarization-item"),
    meta: {
      middleware: [authMiddleware, permissionMiddleware(PERMISSIONS.INVENTORY)],
    },
  },
  {
    path: "/omtk-about-product",
    name: "omtk-about-product",
    props: true,
    component: () => import("../pages/admin/omtk/about-product.vue"),
    meta: {
      middleware: [
        authMiddleware,
        permissionMiddleware(PERMISSIONS.OMTK_PRODUCT),
      ],
    },
  },
  {
    path: "/move-products",
    name: "move-product",
    component: () => import("../pages/admin/omtk/move-product"),
    meta: {
      middleware: [authMiddleware],
    },
  },
  {
    path: "/all-product-omtk",
    name: "all-product-omtk",
    component: () => import("../pages/admin/omtk/ware-houses"),
    meta: {
      middleware: [authMiddleware],
    },
  },
  {
    path: "/split-qr",
    name: "split-qr",
    component: () => import("../pages/admin/split-qr/index"),
    meta: {
      middleware: [authMiddleware, permissionMiddleware(PERMISSIONS.OMTK)],
    },
  },
  {
    path: "/all-product-omtk/:id",
    name: "a-product-omtk",
    props: true,
    component: () => import("../pages/admin/omtk/product"),
    meta: {
      middleware: [authMiddleware],
    },
  },
  {
    path: "/warehouses",
    name: "warehouse-index",
    props: true,
    component: () => import("../pages/admin/warehouse/index"),
    meta: {
      middleware: [authMiddleware, permissionMiddleware(PERMISSIONS.WAREHOUSE)],
    },
  },
  {
    path: "/warehouses/:id",
    // path: "/all-product-omtk/:id",
    name: "warehouse-view",
    props: true,
    // component: () => import("../pages/admin/omtk/product"),
    component: () => import("../pages/admin/warehouse/view"),
    meta: {
      middleware: [authMiddleware, permissionMiddleware(PERMISSIONS.WAREHOUSE)],
    },
  },
  {
    path: "/warehouses/:id/stillage/:columnId/view/:cellId",
    name: "warehouse-stillage-view",
    props: true,
    component: () => import("../pages/admin/warehouse/stillage"),
    meta: {
      middleware: [authMiddleware, permissionMiddleware(PERMISSIONS.WAREHOUSE)],
    },
  },

  {
    path: "/print/products",
    name: "print-products",
    component: () => import("../pages/admin/omtk/print-product"),
    meta: {
      middleware: [authMiddleware, permissionMiddleware(PERMISSIONS.OMTK)],
    },
  },
];
